import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IUploadPtData } from "app/models/core/admin/uploadPt";
import { IEvaluators } from "app/models/core/home/evaluators";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-cliaUpdates',
  templateUrl: './cliaUpdates.component.html',
  styleUrls: ['./cliaUpdates.component.scss']
})

export class CliaUpdatesComponent implements OnInit {

  editMode = '';
  fileName: string = '';
  file: File;
  evaluator = '';
  public eval: IEvaluators[];

  list: IUploadPtData[][] = [];
  listInvalid: IUploadPtData[] = [];
  listValidMicro: IUploadPtData[] = [];
  listValidNonMicro: IUploadPtData[] = [];
  labNames: string[] = [];

  displayedColumns: string[] = ['test', 'testId'];
  displayedColumns2: string[] = ['labName', 'test', 'percent', 'year', 'period'];
  displayedColumns3: string[] = ['stateNumber', 'labName'];

  dataSource = new MatTableDataSource<IUploadPtData>(this.listInvalid);
  dataSource2 = new MatTableDataSource<IUploadPtData>(this.listValidMicro);
  dataSource3 = new MatTableDataSource<IUploadPtData>(this.listValidNonMicro);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  @ViewChild('TablePaginator') paginator2: MatPaginator;
  @ViewChild('TableSort') sort2: MatSort;
  @ViewChild('TablePaginator') paginator3: MatPaginator;
  @ViewChild('TableSort') sort3: MatSort;

  listFilter = '';
  listFilter2 = '';
  listFilter3 = '';

  formGroup = new UntypedFormGroup({
    Evaluator: new UntypedFormControl('', [Validators.required]),
    File: new UntypedFormControl('', [Validators.required])
  });


  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    public labService: LabService) { };

  ngOnInit(): void {
    this.editMode = 'process'
    this.getEvaluators();
  }

  getEvaluators() {
    this.labService.getEvaluators().subscribe(
      res => {
        this.eval = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  onFileSelected(event): void {
    let newFile = event.target.files[0];
    this.file = newFile;
    this.fileName = this.file.name;
  }

  uploadFiles(): void {
    if (this.file != null) {
      var fileData = new FormData();
      fileData.append("file", this.file, this.file.name);
      this.evaluator = this.formGroup.controls['Evaluator'].value;
      this.adminService.uploadPt(fileData, this.evaluator).subscribe(
        res => {
          this.file = null;
          this.fileName = '';
          this.list = res;
          this.process();
          this.timeout();
          this.editMode = 'list';
        },
        error => console.log('error', error)
      );
    }
  }

  savePtTests() {
  }

  reset() {
    this.editMode = 'process';
    this.list = [];
    this.listInvalid = [];
    this.listValidMicro = [];
    this.listValidNonMicro = [];
    this.clearFilter();
    this.clearFilter2();
    this.clearFilter3();
  }

  process() {
    this.listInvalid = this.list[0];
    this.list[1].forEach(function (val) {
      if (val.micro) {
        this.listValidMicro.push(val);
      }
      else {
        this.listValidNonMicro.push(val);
      }
    });
    this.dataSource.data = this.listInvalid;
    this.dataSource2.data = this.listValidMicro;
    this.dataSource3.data = this.listValidNonMicro;

    this.labNames = [...new Set(this.list[1].map(item => item.labName))];
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource2.paginator = this.paginator2;
      this.dataSource2.sort = this.sort2;
      this.dataSource3.paginator = this.paginator3;
      this.dataSource3.sort = this.sort3;
    }, 250);
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }
  filterTable2(evnt: Event) {
    this.listFilter2 = (evnt.target as HTMLInputElement).value;
    this.dataSource2.filter = this.listFilter2.trim().toLowerCase();
  }
  filterTable3(evnt: Event) {
    this.listFilter3 = (evnt.target as HTMLInputElement).value;
    this.dataSource3.filter = this.listFilter3.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }
  clearFilter2() {
    this.listFilter2 = "";
    this.dataSource2.filter = this.listFilter2;
  }
  clearFilter3() {
    this.listFilter3 = "";
    this.dataSource3.filter = this.listFilter3;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }
  getPageSizeOptions2(): number[] {
    if (this.dataSource2.data.length > 20) {
      return [10, 20, this.dataSource2.data.length];
    } else {
      return [10, 20];
    }
  }
  getPageSizeOptions3(): number[] {
    if (this.dataSource3.data.length > 20) {
      return [10, 20, this.dataSource3.data.length];
    } else {
      return [10, 20];
    }
  }

}
